import { put, call, all, spawn, takeEvery, delay } from 'redux-saga/effects';
import { gearServices } from '../services/gear';
import * as types from '../constants/gear';
import * as actions from '../actions/gear';
import { toast } from 'react-toastify';
import parseDjangoError from 'Utils/parseDjangoError';

function* apiGetAllOrgRobotsWorker(action) {
  try {
    const result = yield call(gearServices.apiGetAllOrgRobots, action);
    yield put(actions.apiGetAllOrgRobotsSuccess(result, action));
  } catch (err) {
    yield put(actions.apiGetAllOrgRobotsFailed(err, action));
  }
}
function* apiGetAllOrgRobotsWatcher() {
  yield takeEvery(
    types.API_GET_ALL_ORG_ROBOTS_REQUEST,
    apiGetAllOrgRobotsWorker,
  );
}

function* apiBulkOnboardOrgRobotWorker(action) {
  const toastId = toast.loading('Onboarding robots. Please wait a second...');
  try {
    const response = yield call(gearServices.apiBulkOnboardOrgRobot, action);
    // Best-effort batch: summarise created / already-onboarded / failed counts.
    const result = response.data?.result || {};
    const parts = [];
    if (result.created) parts.push(`${result.created} robot(s) onboarded`);
    if (result.skipped) parts.push(`${result.skipped} already onboarded`);
    if (result.failed) parts.push(`${result.failed} failed`);
    toast.update(toastId, {
      render: parts.length ? parts.join(', ') : 'No robots onboarded',
      type: result.failed ? 'warning' : 'success',
      isLoading: false, autoClose: 4000, closeOnClick: true,
    });
    yield put(actions.apiBulkOnboardOrgRobotSuccess(response.data));
  } catch (error) {
    const message = error.response?.data?.error || 'Bulk Onboard Organization Robot Error';
    toast.update(toastId, {
      render: message,
      type: 'error', isLoading: false, autoClose: 3000, closeOnClick: true,
    });
    yield put(actions.apiBulkOnboardOrgRobotFailed(message));
  }
}
function* apiBulkOnboardOrgRobotWatcher() {
  yield takeEvery(
    types.API_BULK_ONBOARD_ORG_ROBOT_REQUEST,
    apiBulkOnboardOrgRobotWorker,
  );
}

function* apiValidateRobotAirIdWorker(action) {
  try {
    // `result` is {valid, air_id, nick_name} — nick_name only present when claimable.
    const response = yield call(gearServices.apiGetRobotAvailability, action);
    yield put(actions.apiValidateRobotAirIdSuccess(response?.data?.result || {}, action.airId));
  } catch (error) {
    const message = error.response?.data?.error || 'Invalid AIR ID';
    yield put(actions.apiValidateRobotAirIdFailed(message, action.airId));
  }
}
function* apiValidateRobotAirIdWatcher() {
  yield takeEvery(
    types.API_VALIDATE_ROBOT_AIR_ID_REQUEST,
    apiValidateRobotAirIdWorker,
  );
}

function* apiUpdateOrgRobotWorker(action) {
  try {
    const result = yield call(gearServices.apiUpdateOrgRobot, action);
    yield put(actions.apiUpdateOrgRobotSuccess(result, action));
  } catch (err) {
    yield put(actions.apiUpdateOrgRobotFailed(err));
  }
}
function* apiUpdateOrgRobotWatcher() {
  yield takeEvery(
    types.API_UPDATE_ORG_ROBOT_REQUEST,
    apiUpdateOrgRobotWorker,
  );
}

function* apiCreateShootRobotWorker(action) {
  try {
    const result = yield call(gearServices.apiCreateShootRobot, action);
    yield put(actions.apiCreateShootRobotSuccess(result, action));
  } catch (err) {
    yield put(actions.apiCreateShootRobotFailed(err, action));
  }
}
function* apiCreateShootRobotWatcher() {
  yield takeEvery(
    types.API_CREATE_SHOOT_ROBOT_REQUEST,
    apiCreateShootRobotWorker,
  );
}

function* apiGetAllShootRobotsWorker(action) {
  try {
    const result = yield call(gearServices.apiGetAllShootRobots, action);
    yield put(actions.apiGetAllShootRobotsSuccess(result, action));
  } catch (err) {
    yield put(actions.apiGetAllShootRobotsFailed(err, action));
  }
}
function* apiGetAllShootRobotsWatcher() {
  yield takeEvery(
    types.API_GET_ALL_SHOOT_ROBOT_REQUEST,
    apiGetAllShootRobotsWorker,
  );
}

function* apiUpdateShootRobotWorker(action) {
  try {
    const result = yield call(gearServices.apiUpdateShootRobot, action);
    yield put(actions.apiUpdateShootRobotSuccess(result, action));
  } catch (err) {
    yield put(actions.apiUpdateShootRobotFailed(err, action));
  }
}
function* apiUpdateShootRobotWatcher() {
  yield takeEvery(
    types.API_UPDATE_SHOOT_ROBOT_REQUEST,
    apiUpdateShootRobotWorker,
  );
}

function* apiDeleteShootRobotWorker(action) {
  try {
    const result = yield call(gearServices.apiDeleteShootRobot, action);
    yield put(actions.apiDeleteShootRobotSuccess(result, action));
  } catch (err) {
    yield put(actions.apiDeleteShootRobotFailed(err, action));
  }
}
function* apiDeleteShootRobotWatcher() {
  yield takeEvery(
    types.API_DELETE_SHOOT_ROBOT_REQUEST,
    apiDeleteShootRobotWorker,
  );
}

function* apiGetAllOrgInstanceWorker(action) {
  try {
    const result = yield call(gearServices.apiGetAllOrgInstance, action);
    yield put(actions.apiGetAllOrgInstanceSuccess(result, action));
  } catch (err) {
    yield put(actions.apiGetAllOrgInstanceFailed(err, action));
  }
}
function* apiGetAllOrgInstanceWatcher() {
  yield takeEvery(
    types.API_GET_ALL_ORG_INSTANCE_REQUEST,
    apiGetAllOrgInstanceWorker,
  );
}

function* apiOnboardOrgInstanceWorker(action) {
  try {
    const result = yield call(gearServices.apiOnboardOrgInstance, action);
    yield put(actions.apiOnboardOrgInstanceSuccess(result, action));
  } catch (err) {
    yield put(actions.apiOnboardOrgInstanceFailed(err, action));
  }
}
function* apiOnboardOrgInstanceWatcher() {
  yield takeEvery(
    types.API_ONBOARD_ORG_INSTANCE_REQUEST,
    apiOnboardOrgInstanceWorker,
  );
}

function* apiUpdateOrgInstanceWorker(action) {
  try {
    const result = yield call(gearServices.apiUpdateOrgInstance, action);
    yield put(actions.apiUpdateOrgInstanceSuccess(result, action));
  } catch (err) {
    yield put(actions.apiUpdateOrgInstanceFailed(err));
  }
}
function* apiUpdateOrgInstanceWatcher() {
  yield takeEvery(
    types.API_UPDATE_ORG_INSTANCE_REQUEST,
    apiUpdateOrgInstanceWorker,
  );
}

function* apiCreateShootInstanceWorker(action) {
  try {
    const result = yield call(gearServices.apiCreateShootInstance, action);
    yield put(actions.apiCreateShootInstanceSuccess(result, action));
  } catch (err) {
    yield put(actions.apiCreateShootInstanceFailed(err, action));
  }
}
function* apiCreateShootInstanceWatcher() {
  yield takeEvery(
    types.API_CREATE_SHOOT_INSTANCE_REQUEST,
    apiCreateShootInstanceWorker,
  );
}

function* apiGetAllShootInstanceWorker(action) {
  try {
    const result = yield call(gearServices.apiGetAllShootInstance, action);
    yield put(actions.apiGetAllShootInstanceSuccess(result, action));
  } catch (err) {
    yield put(actions.apiGetAllShootInstanceFailed(err, action));
  }
}
function* apiGetAllShootInstanceWatcher() {
  yield takeEvery(
    types.API_GET_ALL_SHOOT_INSTANCE_REQUEST,
    apiGetAllShootInstanceWorker,
  );
}

function* apiUpdateShootInstanceWorker(action) {
  try {
    const result = yield call(gearServices.apiUpdateShootInstance, action);
    yield put(actions.apiUpdateShootInstanceSuccess(result, action));
  } catch (err) {
    yield put(actions.apiUpdateShootInstanceFailed(err, action));
  }
}
function* apiUpdateShootInstanceWatcher() {
  yield takeEvery(
    types.API_UPDATE_SHOOT_INSTANCE_REQUEST,
    apiUpdateShootInstanceWorker,
  );
}

function* apiDeleteShootInstanceWorker(action) {
  try {
    const result = yield call(gearServices.apiDeleteShootInstance, action);
    yield put(actions.apiDeleteShootInstanceSuccess(result, action));
  } catch (err) {
    yield put(actions.apiDeleteShootInstanceFailed(err, action));
  }
}
function* apiDeleteShootInstanceWatcher() {
  yield takeEvery(
    types.API_DELETE_SHOOT_INSTANCE_REQUEST,
    apiDeleteShootInstanceWorker,
  );
}

function* apiGetAllShootInstancesLiveStatusWorker(action) {
  try {
    const result = yield call(gearServices.apiGetAllShootInstancesLiveStatus, action);
    yield put(actions.apiGetAllShootInstancesLiveStatusSuccess(result, action));
  } catch (err) {
    yield put(actions.apiGetAllShootInstancesLiveStatusFailed(err));
  }
}
function* apiGetAllShootInstancesLiveStatusWatcher() {
  yield takeEvery(
    types.API_GET_ALL_SHOOT_INSTANCES_LIVE_STATUS_REQUEST,
    apiGetAllShootInstancesLiveStatusWorker,
  );
}

function* apiGetShootInstanceLiveStatusWorker(action) {
  try {
    const result = yield call(gearServices.apiGetShootInstanceLiveStatus, action);
    yield put(actions.apiGetShootInstanceLiveStatusSuccess(result, action));
  } catch (err) {
    yield put(actions.apiGetShootInstanceLiveStatusFailed(err));
  }
}
function* apiGetShootInstanceLiveStatusWatcher() {
  yield takeEvery(
    types.API_GET_SHOOT_INSTANCE_LIVE_STATUS_REQUEST,
    apiGetShootInstanceLiveStatusWorker,
  );
}

function* apiStartShootInstanceWorker(action) {
  try {
    const result = yield call(gearServices.apiStartShootInstance, action);
    yield put(actions.apiStartShootInstanceSuccess(result, action));
    yield put(actions.apiGetShootInstanceLiveStatusRequest(action.token, action.instanceData.instance_air_id, action.instanceData.region_name)); // Since Redux-saga is async, execute this action here after finishing the first apiStartShootInstance instead of in the component
  } catch (err) {
    yield put(actions.apiStartShootInstanceFailed(err));
  }
}
function* apiStartShootInstanceWatcher() {
  yield takeEvery(
    types.API_START_SHOOT_INSTANCE_REQUEST,
    apiStartShootInstanceWorker,
  );
}

function* apiStopShootInstanceWorker(action) {
  try {
    const result = yield call(gearServices.apiStopShootInstance, action);
    yield put(actions.apiStopShootInstanceSuccess(result, action));
    yield put(actions.apiGetShootInstanceLiveStatusRequest(action.token, action.instanceData.instance_air_id, action.instanceData.region_name));
  } catch (err) {
    yield put(actions.apiStopShootInstanceFailed(err));
  }
}
function* apiStopShootInstanceWatcher() {
  yield takeEvery(
    types.API_STOP_SHOOT_INSTANCE_REQUEST,
    apiStopShootInstanceWorker,
  );
}

function* apiUpdateRobotZCamSingleSettingWorker(action) {
  let toastId;
  try {
    const robotName = action.robotName;
    toastId = toast.info(`Updating ${robotName} Zcam setting...`, { autoClose: 5000 });
    const res = yield call(gearServices.apiUpdateRobotZCamSingleSetting, action);
    yield put(actions.apiUpdateRobotZCamSingleSettingSuccess(res));

    toast.update(toastId, {
      render: res?.data?.result || `Successfully update Zcam setting!`,
      type: toast.TYPE.SUCCESS,
      autoClose: 3000,
      closeOnClick: true,
    });
  } catch (error) {
    const errorMsg = error.response?.data?.error || 'Unknown error';
    yield put(actions.apiUpdateRobotZCamSingleSettingFailed(errorMsg));
    const robotName = action.robotName;
    toast.update(toastId, {
      render: `${robotName} Error: ${errorMsg}`,
      type: toast.TYPE.SUCCESS,
      autoClose: 3000,
      closeOnClick: true,
    });
  }
}
function* apiUpdateRobotZCamSingleSettingWatcher() {
  yield takeEvery(
    types.API_UPDATE_ROBOT_ZCAM_SINGLE_SETTING_REQUEST,
    apiUpdateRobotZCamSingleSettingWorker,
  );
}

function* apiGetInventoryOnPremServerInfoWorker(action) {
  try {
    const response = yield call(gearServices.apiGetInventoryOnPremServerInfo, action);
    const inventoryOnPremServerInfo = response?.data?.data || {};
    yield put(actions.apiGetInventoryOnPremServerInfoSuccess(inventoryOnPremServerInfo));
  } catch (error) {
  }
}
function* apiGetInventoryOnPremServerInfoWatcher() {
  yield takeEvery(
    types.API_GET_INVENTORY_ON_PREM_SERVER_INFO_REQUEST,
    apiGetInventoryOnPremServerInfoWorker,
  );
}

function* apiOnboardOrgOnPremServerWorker(action) {
  let toastId;
  try {
    toastId = toast.info(`Onboarding AutoPilot server for your organization...`, { autoClose: 5000 });
    const response = yield call(gearServices.apiOnboardOrgOnPremServer, action);
    const newOrgOnPremServer = response?.data?.data || {};
    yield put(actions.apiOnboardOrgOnPremServerSuccess(newOrgOnPremServer));

    toast.update(toastId, {
      render: `AutoPilot server onboarded successfully!`,
      type: toast.TYPE.SUCCESS,
      autoClose: 3000,
      closeOnClick: true,
    });
  } catch (error) {
    const errorMsg = parseDjangoError(error.response?.data?.error) || 'Unknown error';
    yield put(actions.apiOnboardOrgOnPremServerFailed(errorMsg));

    toast.update(toastId, {
      render: `AutoPilot server onboarding error: ${errorMsg}`,
      type: toast.TYPE.ERROR,
      autoClose: 3000,
      closeOnClick: true,
    });
  }
}
function* apiOnboardOrgOnPremServerWatcher() {
  yield takeEvery(
    types.API_ONBOARD_ORG_ON_PREM_SERVER_REQUEST,
    apiOnboardOrgOnPremServerWorker,
  );
}

function* apiUpdateOrgOnPremServerWorker(action) {
  let toastId;
  try {
    toastId = toast.info(`Updateing AutoPilot Server...`, { autoClose: 5000 });
    const response = yield call(gearServices.apiUpdateOrgOnPremServer, action);
    const updateOrgOnPremServer = response?.data?.data || {};
    yield put(actions.apiUpdateOrgOnPremServerSuccess(updateOrgOnPremServer));

    toast.update(toastId, {
      render: `AutoPilotServer update successfully!`,
      type: toast.TYPE.SUCCESS,
      autoClose: 3000,
      closeOnClick: true,
    });
  } catch (error) {
    const errorMsg = parseDjangoError(error.response?.data?.error) || 'Unknown error';
    yield put(actions.apiUpdateOrgOnPremServerFailed(errorMsg));

    toast.update(toastId, {
      render: `AutoPilot Server update error: ${errorMsg}`,
      type: toast.TYPE.ERROR,
      autoClose: 3000,
      closeOnClick: true,
    });
  }
}
function* apiUpdateOrgOnPremServerWatcher() {
  yield takeEvery(
    types.API_UPDATE_ORG_ON_PREM_SERVER_REQUEST,
    apiUpdateOrgOnPremServerWorker,
  );
}

function* apiGetAllOrgOnPremServersWorker(action) {
  try {
    const response = yield call(gearServices.apiGetAllOrgOnPremServers, action);
    const allOrgOnPremServers = response?.data?.data || [];
    yield put(actions.apiGetAllOrgOnPremServersSuccess(allOrgOnPremServers));
  } catch (error) {
    const errorMsg = parseDjangoError(error.response?.data?.error) || 'Unknown error';
    yield put(actions.apiGetAllOrgOnPremServersFailed(errorMsg));
  }
}
function* apiGetAllOrgOnPremServersWatcher() {
  yield takeEvery(
    types.API_GET_ALL_ORG_ON_PREM_SERVERS_REQUEST,
    apiGetAllOrgOnPremServersWorker,
  );
}

// Read more information about root sagas in the documentation
// https://redux-saga.js.org/docs/advanced/RootSaga.html
export default function* gearRootSaga() {
  const sagas = [
    apiGetAllOrgRobotsWatcher,
    apiBulkOnboardOrgRobotWatcher,
    apiValidateRobotAirIdWatcher,
    apiUpdateOrgRobotWatcher,
    apiCreateShootRobotWatcher,
    apiGetAllShootRobotsWatcher,
    apiUpdateShootRobotWatcher,
    apiDeleteShootRobotWatcher,
    apiGetAllOrgInstanceWatcher,
    apiOnboardOrgInstanceWatcher,
    apiUpdateOrgInstanceWatcher,
    apiCreateShootInstanceWatcher,
    apiGetAllShootInstanceWatcher,
    apiUpdateShootInstanceWatcher,
    apiDeleteShootInstanceWatcher,
    apiGetAllShootInstancesLiveStatusWatcher,
    apiGetShootInstanceLiveStatusWatcher,
    apiStartShootInstanceWatcher,
    apiStopShootInstanceWatcher,
    apiUpdateRobotZCamSingleSettingWatcher,
    apiGetInventoryOnPremServerInfoWatcher,
    apiOnboardOrgOnPremServerWatcher,
    apiUpdateOrgOnPremServerWatcher,
    apiGetAllOrgOnPremServersWatcher,
  ];

  yield all(
    sagas.map(saga =>
      spawn(function* () {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            console.log(e);
          }
        }
      }),
    ),
  );
}